import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import contractorsService from "./contractorsServices";

const initialState = {
  contractors: {},
  isError: false,
  isSuccess: false,
  isLodaing: false,
  massage: "",
};

export const get_all_contractors = createAsyncThunk(
  "contractors/getAll",
  async (thunkAPI) => {
    try {
      return await contractorsService.Get_Contractors_Action();
    } catch (error) {
      const massage = error.message;
      return thunkAPI.rejectWithValue(massage);
    }
  }
);

export const contractorsSlice = createSlice({
  name: "contractors",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLodaing = false;
      state.isDeleteLodaing = false;
      state.massage = "";
    },
  },
  extraReducers: {
    [get_all_contractors.pending]: (state) => {
      state.isLodaing = true;
    },
    [get_all_contractors.fulfilled]: (state, action) => {
      state.isLodaing = false;
      state.contractors = action.payload;
      state.isSuccess = true;
    },
    [get_all_contractors.rejected]: (state, action) => {
      state.isLodaing = false;
      state.isError = true;
      state.massage = action.payload;
    },
  },
});

export const { reset } = contractorsSlice.actions;
export default contractorsSlice.reducer;
